import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Data from '../entities/data'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface DataState extends ListState<Data>{
    editData:Data
    editStatus:Data
}
class UserMutations extends ListMutations<Data>{

}
class DataModule extends ListModule<DataState,any,Data>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Data>(),
        loading:false,
        editData:new Data(),
        editStatus:new Data(),
    }
    actions={
        async getAllPaged(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Data/GetAllPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Data>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getWarningPaged(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Data/GetWarningPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Data>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getWareHouseList(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Data/GetWareHouseList',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Data>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return 1;
        },
        async getPaged(context:ActionContext<DataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Data/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Data>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPagedLast(context: ActionContext<DataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Data/GetPagedLast', { params: payload.data });
            let page = reponse.data.result as PageResult<Data>;
            return page.items;
        },
        async getPageByDate(context: ActionContext<DataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Data/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<Data>;
            return page.items;
        },
        async getWeekDatas(context: ActionContext<DataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Data/GetWeekDatas', { params: payload.data });
            return reponse.data.result;
        },
        async create(context:ActionContext<DataState,any>,payload:any){
            await Ajax.post('/api/services/app/Data/Create',payload.data);
        },
        async update(context:ActionContext<DataState,any>,payload:any){
            await Ajax.put('/api/services/app/Data/Update',payload.data);
        },
        async delete(context:ActionContext<DataState,any>,payload:any){
            await Ajax.delete('/api/services/app/Data/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<DataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Data/GetById?Id='+payload.id);
            return reponse.data.result as Data;
        },
        async getWarning(context:ActionContext<DataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Data/GetWarningList');
            return reponse.data.result.items;
        },
        async getRank(context:ActionContext<DataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Data/GetRankList?day='+payload.data);
            return reponse.data.result.items;
        }

    };
    mutations={
        setCurrentPage(state:DataState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:DataState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:DataState,data:Data){
            
            state.editData=data;
            state.editStatus=data;
            //console.log(state.editFloor);
        }
    }
}
const dataModule=new DataModule();
export default dataModule;